import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Layout, message } from "antd";
import { Outlet } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import Logo from "@/components/common/Logo";
import Navigator from "@/components/common/Navigator";
import UserProfile from "@/components/common/UserProfile";
import styles from "./index.module.less";

function WorkshopLayout() {
  const [time, setTime] = useState(Date.now());
  const dispatch = useDispatch();
  const operate = useCallback(() => {
    const now = Date.now();
    if (now - time > 3600000) {
      message.warning("登录已超时，请重新登录");
      dispatch.user.logout();
    } else if (Date.now() - time > 1000) {
      setTime(Date.now());
    }
  }, [time, setTime, dispatch]);

  return (
    <div
      onMouseMove={(e) => {
        operate();
      }}
    >
      <Layout className={styles.adminLayout}>
        <Layout.Sider width={270}>
          <Logo />
          <Navigator />
        </Layout.Sider>
        <Layout>
          <Layout.Header className="site-layout-sub-header-background">
            <UserProfile />
          </Layout.Header>
          <Layout.Content>
            <div className="site-layout-background">
              <Scrollbars>
                <Outlet />
              </Scrollbars>
            </div>
          </Layout.Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default WorkshopLayout;
